module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"users":{"profile":{"vanguard_badge":{"description":"Vanguard 360 Alumni","title":"Vanguard 360 Berater Programm"}}}}}}}')
  delete Component.options._Ctor
}
